import React, { useState } from "react";
import "./HeroSection.css";

const HeroSection = () => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const videoId = "uJFGbpYKy48";
  const heroBackground = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${process.env.PUBLIC_URL}/studio-bg-optimized.jpg)`
  };

  const handleVideoLoad = () => {
    setIsVideoLoaded(true);
  };

  return (
    <section className="hero" id="home" style={heroBackground}>
      <div className="hero-content">
        <h1>Abbott Music Studio</h1>
        <p>Creating exceptional soundscapes for film, television, music, and corporate content in the heart of Abbottabad</p>
        <div className="hero-buttons">
          <a href="#services" className="btn-primary">Explore Services</a>
          <a href="#equipment" className="btn-secondary">View Facilities</a>
        </div>
      </div>
      <div className="hero-video">
        {!isVideoLoaded ? (
          <div
            className="hero-video-thumbnail"
            style={{
              backgroundImage: `url(https://img.youtube.com/vi/${videoId}/maxresdefault.jpg)`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            onClick={handleVideoLoad}
          >
            <div className="hero-play-button">▶</div>
          </div>
        ) : (
          <iframe
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
            width="100%"
            height="420"
            title="Abbott Music Studio Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        )}
      </div>
    </section>
  );
};

export default HeroSection;
